// @ts-nocheck



import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { withUserAccess } from './../../withUserAccess';

import {
  addAccessRightContractVehicleBudget,
  addAccessRightWorkPlans } from
'./fixed/accessRight';

import {
  FixedRegistrBudgetAssignments,
  FixedRegistrBudgetBudgetList,
  FixedRegistrBudgetList,
  FixedRegistrBudgetVehicleCard,
  FixedRegistrBudgetExpenseDirectionCard,
  FixedRegistrBudgetVehicleListCard,
  FixedRegistrBudgetVehicleListForm,
  FixedWorkPlansCard,
  FixedWorkPlansForm,
  FixedWorkPlansList } from
'./fixed';
import { RouteComponent } from '../../../lib/routerAdapter';

export default withUserAccess(({ userAccess }) => {
  const canAddContractVehicleBudget = userAccess.some((access) =>
  addAccessRightContractVehicleBudget.includes(access)
  );
  const canAddWorkPlans = userAccess.some((access) =>
  addAccessRightWorkPlans.includes(access)
  );
  return (
    <>
      <Routes>
        <Route path="fixed" element={<RouteComponent component={FixedRegistrBudgetList} />} />
        {canAddContractVehicleBudget &&
        <Route path="fixed/new" element={<RouteComponent component={FixedRegistrBudgetVehicleListForm} />} />
        }
        {canAddContractVehicleBudget &&
        <Route
          path="fixed/:contractVehiclePlanId/clone"
          element={<RouteComponent component={FixedRegistrBudgetVehicleListForm} />} />

        }
        <Route path="fixed/:contractVehiclePlanId/card" element={<RouteComponent component={FixedRegistrBudgetVehicleListCard} />} />
        <Route path="fixed/:contractVehiclePlanId/assignments" element={<RouteComponent component={FixedRegistrBudgetAssignments} />} />
        <Route path="fixed/:contractVehiclePlanId/budget" element={<RouteComponent component={FixedRegistrBudgetBudgetList} />} />
        <Route
          path="fixed/:contractVehiclePlanId/budget/:contractVehicleBudgetId/expense-direction/:type"
          element={<RouteComponent component={FixedRegistrBudgetExpenseDirectionCard} />} />

        <Route
          path="fixed/:assignmentLimitId/budget/vehicle"
          element={<RouteComponent component={FixedRegistrBudgetVehicleCard} />} />


        <Route path="work-plans" element={<RouteComponent component={FixedWorkPlansList} />} />
        <Route path="work-plans/:regulationId/card" element={<RouteComponent component={FixedWorkPlansCard} />} />
        {canAddWorkPlans &&
        <Route path="work-plans/new" element={<RouteComponent component={FixedWorkPlansForm} />} />
        }
      </Routes>
    </>);

});
